var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdbabyColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "CD Baby logo Blue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".logo-blue{fill:#40bcd0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-blue",
    d: "M17.9,18.54a18.07,18.07,0,0,0,0,36.08.9.9,0,0,0,1-.9V19.44a.91.91,0,0,0-.91-.91h0m19.12,0a18.07,18.07,0,0,0,0,36.08.9.9,0,0,0,1-.9V19.44a.91.91,0,0,0-.91-.91h0m22.25,1V54.21a.53.53,0,0,0,.54.54,18.07,18.07,0,0,0,.41-36.11h0a.9.9,0,0,0-.9.91M39.47,1.4c0,5.43,0,32.45,0,34.94a2.3,2.3,0,0,0,0,.37c1.47,16.43,14.73,17.91,17.63,18a.52.52,0,0,0,.56-.53V31s0-10.65,0-12.28c0-.13,0-.27,0-.41C56.49,3.09,44.05.85,40.45.52h-.09a.89.89,0,0,0-.89.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo-blue",
    d: "M83.78,50.73a3.91,3.91,0,1,1-3.91-3.9,3.91,3.91,0,0,1,3.91,3.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdbabyColor);
export default __webpack_public_path__ + "static/media/cdbaby-color.0ad16d72ffe43fb88d8121225853608f.svg";
export { ForwardRef as ReactComponent };